"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const axios_1 = __importDefault(require("axios"));
const lodash_1 = __importDefault(require("lodash"));
const sizeof_1 = require("sizeof");
class Logger {
    constructor(url, info) {
        this.LOG_MAX_LENGTH = 500;
        this.LOG_MAX_SIZE = 1000000;
        this.FLUSH_INTERVAL = 15000;
        this.logs = [];
        this.loggerUrl = url;
        this.labels = info;
        this.start();
    }
    start() {
        if (this.flushIntervalId != null) {
            this.stop();
        }
        this.flushIntervalId = setInterval(() => {
            this.flush();
        }, this.FLUSH_INTERVAL);
    }
    stop() {
        clearInterval(this.flushIntervalId);
    }
    setMerchantId(merchantId) {
        this.labels.merchantId = merchantId;
    }
    setDeviceId(deviceId) {
        this.labels.deviceId = deviceId;
    }
    setUserId(userId) {
        this.labels.userId = userId;
    }
    setEnv(environment) {
        this.labels.environment = environment;
    }
    log(level, data) {
        this.logs.push({
            level,
            data,
        });
        let logSize;
        try {
            logSize = sizeof_1.sizeof(this.logs);
        }
        catch (error) {
            logSize = this.LOG_MAX_LENGTH;
        }
        if (this.logs.length >= this.LOG_MAX_LENGTH ||
            logSize >= this.LOG_MAX_SIZE) {
            this.flush();
        }
    }
    flush() {
        if (this.logs.length === 0)
            return;
        const logs = lodash_1.default.clone(this.logs);
        this.logs = [];
        axios_1.default.post(this.loggerUrl, {
            logs,
            labels: lodash_1.default.chain(this.labels).omitBy(lodash_1.default.isNull).omitBy(lodash_1.default.isUndefined).value(),
        })
            .then(() => {
            console.log(`${logs.length} logs sended`);
        })
            .catch((error) => {
            console.log(`${logs.length} logs sended failed`, error);
        });
    }
}
exports.default = Logger;
//# sourceMappingURL=Logger.js.map